import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "@/reducers/hooks"
import { selectChat } from "@/reducers/chatsSliceSelectors"
import { changeActiveChat } from "@/reducers/chatsSlice"
import { changeActiveTab, TAB_TYPES } from "@/reducers/tabsSlice"
import { isMucJid } from "@/jidUtils"
import { parse as jidParse } from "@/lib/cachedJid"
import { isMobile } from "@/utils/detectDevice"
import { mobileRoutes, setMobileRoute } from "@/routes/routes"

export const useForwardedRoomLink = (from: string | undefined) => {
  const dispatch = useAppDispatch()

  const sourceRoomJid =
    from && isMucJid(from) ? jidParse(from).bare().toString() : undefined

  const sourceChat = useAppSelector(selectChat(sourceRoomJid ?? ""))

  const navigateToRoom = useCallback(() => {
    if (!sourceRoomJid || !sourceChat) return
    dispatch(changeActiveTab({ activeTab: TAB_TYPES.CHATS }))
    dispatch(changeActiveChat({ activeChatJid: sourceRoomJid }))
    if (isMobile) {
      setMobileRoute(mobileRoutes.CHAT)
    }
  }, [dispatch, sourceRoomJid, sourceChat])

  return {
    roomName: sourceChat?.name,
    roomJid: sourceRoomJid,
    navigateToRoom,
  }
}
